
import {map} from 'nanostores';


export const $productConfig = map({
    storage_data_key: 'trit_zayav_data',
    storage_session_key: 'trit_zayav_session',
    storage_save_intvl: 3000,
    storage_error_intvl: 5000,
    // api urls    
    siteconfig_url: 'api/v1/siteconfig',
    status_url: (uid) => `api/v1/status/${uid}`,
    status_qr_url: (uid) => `api/v1/status/${uid}/qr.png`,
    restore_url: 'api/v1/restore',
    post_url: 'api/v1/post?act=submit&type=trit_zayav_data',
    // navigate urls
    return_url: 'https://izhtrit.ru/priemkom/'
});

